<template>
  <div class="enroll-pin-view">
    <div class="relative flex flex-col h-screen">
      <img :src="getImage('mascot')" class="fixed papsi-mascot" />
      <div class="flex flex-1 lg:flex-row flex-col">
        <SidebarSection>
          <LabelControl type="message" :content="$t('enp008')" />
        </SidebarSection>
        <ContentSection :show_logout="true" :show_back="false" @logout="logout">
          <div class="text-left">
            <div
              class="bg-grey-lighter p-10 rounded-2xl mt-4 papsi-container-enroll"
            >
              <div class="flex flex-row items-center justify-center mb-10">
                <img :src="getImage('edit-pin')" style="width: 12rem" />
              </div>
              <div class="flex flex-col">
                <p class="text-grey-darkest text-3xl">
                  {{ $t("enp009") }}
                </p>
              </div>
              <div class="flex flex-col">
                <p class="text-grey-darkest text-3xl mt-8 font-semibold">
                  {{ $t("enp010") }}
                </p>
              </div>
              <ButtonControl
                text="Update PIN"
                class="w-full -mb-1"
                theme="success"
                @click="toggleEditPINModal()"
              />
            </div>
          </div>
        </ContentSection>
      </div>
      <EditPINModalControl :is_editing_temp="true" ref="EditPINModal" />
      <FooterSection />
    </div>
    <!-- Privacy Policy -->
    <transition name="slide-in">
      <ModalControl
        :is_visible="this.toggle_privacy"
        is_scrollable
        is_table
        :overlay_enabled="true"
      >
        <div class="flex flex-col justify-center pt-10 px-10">
          <LabelControl
            type="dynamic"
            class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
            content="Privacy Policy"
          />
          <PrivacyPolicyControl />
          <div
            class="flex flex-row justify-center align-center items-center w-full"
            style="gap: 3rem"
          >
            <ButtonControl
              text="I Disagree"
              theme="error"
              @click="toggle_privacy = false"
              class="w-full"
            />
            <ButtonControl
              text="I Agree"
              class="px-8 mr-5 w-full"
              theme="success"
              @click="handlePrivacyAgreementPIN()"
            />
          </div>
        </div>
      </ModalControl>
    </transition>
  </div>
</template>

<script>
import SidebarSection from "@/components/sections/SidebarSection.vue";
import ContentSection from "@/components/sections/ContentSection.vue";
import FooterSection from "@/components/sections/FooterSection.vue";
import LabelControl from "@/components/controls/LabelControl.vue";
import EditPINModalControl from "@/components/controls/EditPINModalControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import PrivacyPolicyControl from "@/components/controls/PrivacyPolicyControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import mixin from "@/mixins/controls.js";
export default {
  name: "EditPINView",
  mixins: [mixin],
  components: {
    SidebarSection,
    ContentSection,
    FooterSection,
    LabelControl,
    EditPINModalControl,
    ModalControl,
    PrivacyPolicyControl,
    ButtonControl,
  },
  inject: ["setLoading", "setError"],
  emits: ["logout", "checkauth"],
  mounted() {
    this.$emit("checkauth", true);
    this.startInactivityTimer();
    window.addEventListener("touchstart", this.resetInactivityTimer);
  },
  beforeUnmount() {
    clearTimeout(this.inactivity_timeout);
    window.removeEventListener("touchstart", this.resetInactivityTimer);
  },
  computed: {
    getCensoredEmail() {
      if (this.email) {
        let [local_part, domain_part] = this.email.split("@");
        const censored_count = Math.ceil(this.email.length * 0.7);
        const indices = Array.from({ length: this.email.length }, (_, i) => i);
        const eligible_indices = indices.slice(2);

        // shuffling string indices
        for (let i = eligible_indices.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [eligible_indices[i], eligible_indices[j]] = [
            eligible_indices[j],
            eligible_indices[i],
          ];
        }

        const censored_indices = eligible_indices.slice(0, censored_count);
        local_part = local_part
          .split("")
          .map((char, i) => (censored_indices.includes(i) ? "*" : char))
          .join("");

        return `${local_part}@${domain_part}`;
      }
      return "";
    },
    getCensoredNumber() {
      return this.mobile
        ? this.mobile.slice(0, 5) +
            "*".repeat(this.mobile.length - 9) +
            this.mobile.slice(-4)
        : "";
    },
    isPINValid() {
      if (this.is_inputting_new_pin) {
        return this.new_pin.length == 6;
      } else if (this.is_inputting_confirm_pin) {
        return this.confirm_pin.length == 6;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      toggle_privacy: false,
      nextActionPIN: null,
    };
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivity_timeout);
      this.startInactivityTimer();
    },
    startInactivityTimer() {
      if (process.env.VUE_APP_DEVELOPMENT_MODE === "false") {
        this.inactivity_timeout = setTimeout(() => {
          this.$router.push({ name: "start-page" });
        }, process.env.VUE_APP_IDLE_DELAY || 30000);
      }
    },
    logout() {
      this.$emit("logout");
    },
    toggleEditPINModal() {
      if (!this.$store.state.user.hasAgreedToPrivacyPIN) {
        this.toggle_privacy = true; // Show privacy modal first
        this.nextActionPIN = () => this.$refs.EditPINModal.openEditModal(); // Store the next action
      } else {
        this.$refs.EditPINModal.openEditModal(); // Open PIN modal directly if already agreed
      }
    },
    handlePrivacyAgreementPIN() {
      this.$store.commit("updateHasAgreedToPrivacy", {
        field: "hasAgreedToPrivacyPIN",
        value: true,
      });
      this.toggle_privacy = false; // Close privacy modal
      if (this.nextActionPIN) {
        this.nextActionPIN(); // Execute the stored action (open PIN modal)
        this.nextActionPIN = null; // Clear the stored action
      }
    },
  },
};
</script>

<style scoped>
.papsi-mascot {
  bottom: 0;
  left: 0;
  width: 25rem;
}
</style>
